import React, { useEffect, useRef, useState } from "react";
import { baseUrl, config } from "../../../../services/config";
import { Paper } from "@material-ui/core";
import { Modal, Spinner, Table } from "react-bootstrap";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import { upperCase } from "lodash";
import Select from "react-select";
import { DatePicker } from "antd";
import { DownloadTableExcel } from "react-export-table-to-excel";
const { RangePicker } = DatePicker;

const SchoolBookStock = () => {
  const [yearId, setYearId] = useState("");
  const [sessionData, setSessionData] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [customerId, setCustomerId] = useState("");
  const [isCombine, setIsCombine] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [sessionName, setSessionName] = useState("");
  const [debitSum, setDebitSum] = useState(0);
  const [creditSum, setCreditSum] = useState(0);
  const [lossDebited, setLossDebited] = useState(0);
  const [profitCredited, setProfitCredited] = useState(0);
  const [viewModal, setViewModal] = useState(false);
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setendDate] = useState("");

  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const tableRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  let authtoken = localStorage.getItem("userToken");
  const alert = useAlert();

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  const pageStyle = `
  @page {
    size: a4 !important;
  }
  `;

  useEffect(() => {
    getSettingData();
    sessions();
    getCustomers();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_financial_year == "1") {
            setYearId(session.id);
            setSessionName(session.year);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getCustomers = async () => {
    await fetch(`${baseUrl}/school-accounts`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          let arr = [];
          data.payload.forEach((element) => {
            arr.push({
              label: element.school_name,
              value: element.customer_id ?? "",
            });
          });
          setCustomerList(arr);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const datePicker = (value, dateString) => {
    console.log("Formatted Selected Time: ", dateString);
    setStartDate(dateString[0]);
    setendDate(dateString[1]);
  };

  const handleGetData = () => {
    // if (yearId == "") {
    //   alert.error("Please select the year");
    //   return;
    // }

    setLoading(true);
    setIsVisible(false);

    const data = {
      fiscal_year_id: yearId,
      customer_id: customerId,
      start_date: startDate,
      end_date: endDate,
    };
    fetch(`https://pos.daspak.org/api/sales`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        setIsVisible(true);
        if (Array.isArray(data?.data)) {
          const filteredData = data.data.filter((item) =>
            customerList.some((customer) => customer.value == item.customer_id),
          );
          console.log("data", filteredData);

          setReportData(filteredData);
        } else {
          setReportData([]);
          alert.error("No Record Found");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err is re", err);
      });
  };
  //for print
  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const calckNumberDebit = (data) => {
    const totalDebit = data.reduce((a, c) => a + parseInt(c.debit), 0);
    const totalCredit = data.reduce((a, c) => a + parseInt(c.credit), 0);
    if (totalDebit > totalCredit) {
      return Number(totalDebit) - Number(totalCredit);
    } else {
      return 0;
    }
  };
  const calckNumberCredit = (data) => {
    const totalDebit = data.reduce((a, c) => a + parseInt(c.debit), 0);
    const totalCredit = data.reduce((a, c) => a + parseInt(c.credit), 0);
    if (totalCredit > totalDebit) {
      return Number(totalCredit) - Number(totalDebit);
    } else {
      return 0;
    }
  };

  const mainNumberCalc = (data) => {
    let totalDebit = 0;
    let totalCredit = 0;
    data.map((item) => {
      item.sub_account.map((last) => {
        totalDebit += parseInt(last.debit);
      });
      item.sub_account.map((last) => {
        totalCredit += parseInt(last.credit);
      });
    });
    if (totalDebit > totalCredit) {
      return `Total Loss: ${totalDebit - totalCredit}`;
    } else {
      return `Total Profit: ${totalCredit - totalDebit}`;
    }
  };

  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row">
          <div className="col-md-3">
            <label>
              <b>Select Session</b>
            </label>
            <div className="d-flex flex-column ">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                value={yearId}
                aria-label="Default select example"
                onChange={(e) => {
                  const data = sessionData.find((ses) => {
                    return ses.id == e.target.value;
                  });
                  setSessionName(data?.year);
                  setYearId(e.target.value);
                }}
              >
                <option value="">Select Session</option>
                {sessionData &&
                  sessionData.map((item) => (
                    <option value={item.id}>{item.year}</option>
                  ))}
              </select>
            </div>
          </div>

          <div className="col-md-3">
            <label>
              <b>Select Customer</b>
            </label>
            <Select
              onChange={(e) => setCustomerId(e.value)}
              placeholder="Select Customer"
              options={customerList}
            />
          </div>
          <div className="col-md-3">
            <label>
              <b>Select Start & End Date</b>
            </label>
            <RangePicker
              getPopupContainer={(triggerNode) => {
                return triggerNode.parentNode;
              }}
              style={{ height: "40px" }}
              onChange={datePicker}
            />
          </div>

          <div className="col-md-3 mt-md-13">
            <label className="checkbox checkbox-single">
              <input
                type="checkbox"
                className="form-checkbox"
                checked={isCombine}
                onChange={(e) => setIsCombine(e.target.checked)}
              />
              <span />
              &nbsp;&nbsp;&nbsp;Combine School Stock
            </label>
          </div>

          <div className="col-md-3 mt-5">
            <button className="btn btn-primary" onClick={handleGetData}>
              Show
            </button>
            {reportData?.length > 0 ? (
              <>
                <ReactToPrint
                  documentTitle={`School Books Stock Report`}
                  pageStyle={pageStyle}
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      disabled={printloading ? true : false}
                      className="btn btn-primary w-105px mx-2"
                    >
                      {printloading ? <span>Printing..</span> : "Print"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />

                <DownloadTableExcel
                  filename="Trial Balance"
                  sheet="TrialBalance"
                  currentTableRef={tableRef.current}
                >
                  <button className="btn btn-primary mx-2"> Export </button>
                </DownloadTableExcel>
              </>
            ) : null}
          </div>
        </div>

        <div className="mt-5">
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner class="text-center" variant="info" animation="border" />
            </div>
          ) : isVisible ? (
            <div id="tableboot mt-4">
              <div className="d-flex">
                <div>
                  <img
                    style={{ height: 100, width: 110 }}
                    src={icon}
                    alt="logo"
                  />
                </div>
                <div className="mx-5" style={{ paddingTop: "10px" }}>
                  <h1>{unitName}</h1>
                  <h3>
                    School Books Stock For The Financial Year {sessionName} Till
                    Date {date}
                  </h3>
                </div>
              </div>
              <Table className="mt-4" responsive>
                <thead>
                  <tr id="tbl">
                    <th className="text-center">School Name</th>
                    {!isCombine && <th className="text-center">Title</th>}
                    <th className="text-center">Quantity</th>
                    <th className="text-center">Amount</th>
                  </tr>
                </thead>

                <tbody>
                  {Array.isArray(reportData) &&
                    reportData.map((schoolBook, sbIndex) => (
                      <React.Fragment key={sbIndex}>
                        {isCombine ? (
                          <tr className="tbl">
                            <td
                              className="text-center text-color-primary"
                              style={{ fontSize: "1.1rem" }}
                            >
                              {
                                customerList.find(
                                  (customer) =>
                                    customer.value == schoolBook?.customer_id,
                                )?.label
                              }{" "}
                              ({schoolBook?.customer_name})
                            </td>
                            <td
                              className="text-center"
                              style={{ fontSize: "1.1rem" }}
                            >
                              {Intl.NumberFormat("en-US").format(
                                schoolBook?.total_quantity || 0,
                              )}
                            </td>
                            <td
                              className="text-center"
                              style={{ fontSize: "1.1rem" }}
                            >
                              {Intl.NumberFormat("en-US").format(
                                schoolBook?.grand_total || 0,
                              )}
                            </td>
                          </tr>
                        ) : (
                          <>
                            {/* Customer Header */}
                            <tr className="tbl">
                              <td
                                colSpan={4}
                                className="text-start text-color-primary"
                                style={{
                                  fontSize: "1.3rem",
                                  fontWeight: "bold",
                                }}
                              >
                                {
                                  customerList.find(
                                    (customer) =>
                                      customer.value == schoolBook?.customer_id,
                                  )?.label
                                }{" "}
                                ({schoolBook?.customer_name})
                              </td>
                            </tr>

                            {/* Items */}
                            {Array.isArray(schoolBook?.items) &&
                              schoolBook.items.map((item, itemIndex) => (
                                <tr className="tbl" key={itemIndex}>
                                  <td></td>
                                  <td
                                    className="text-center"
                                    style={{ fontSize: "1.1rem" }}
                                  >
                                    {item?.title}
                                  </td>
                                  <td
                                    className="text-center"
                                    style={{ fontSize: "1.1rem" }}
                                  >
                                    {Intl.NumberFormat("en-US").format(
                                      item?.quantity || 0,
                                    )}
                                  </td>
                                  <td
                                    className="text-center"
                                    style={{ fontSize: "1.1rem" }}
                                  >
                                    {Intl.NumberFormat("en-US").format(
                                      item?.total || 0,
                                    )}
                                  </td>
                                </tr>
                              ))}

                            {/* Totals */}
                            <tr className="tbl">
                              <td className="text-center fw-bold"></td>
                              <td
                                className="text-center fw-bold"
                                style={{
                                  fontSize: "1.2rem",
                                  borderTop: "2px solid black",
                                  borderBottom: "2px solid black",
                                }}
                              >
                                Total
                              </td>
                              <td
                                className="text-center fw-bold"
                                style={{
                                  fontSize: "1.2rem",
                                  borderTop: "2px solid black",
                                  borderBottom: "2px solid black",
                                }}
                              >
                                {Intl.NumberFormat("en-US").format(
                                  schoolBook?.total_quantity || 0,
                                )}
                              </td>
                              <td
                                className="text-center fw-bold"
                                style={{
                                  fontSize: "1.2rem",
                                  borderTop: "2px solid black",
                                  borderBottom: "2px solid black",
                                }}
                              >
                                {Intl.NumberFormat("en-US").format(
                                  schoolBook?.grand_total || 0,
                                )}
                              </td>
                            </tr>
                          </>
                        )}
                      </React.Fragment>
                    ))}

                  <tr id="tbl">
                    {!isCombine && (
                      <td
                        style={{ color: "black", paddingLeft: "30px" }}
                        className="text-start"
                      ></td>
                    )}
                    <td
                      style={{
                        fontSize: "1.3rem",
                        paddingRight: "50px",
                        fontWeight: "bold",
                      }}
                      className="text-end text-color-primary"
                    >
                      Grand Total :-
                    </td>

                    <td
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                      className="text-center text-color-primary"
                    >
                      {Intl.NumberFormat("en-Us").format(
                        Array.isArray(reportData)
                          ? reportData.reduce(
                              (sum, item) =>
                                sum + Number(item.total_quantity || 0),
                              0,
                            )
                          : 0,
                      )}
                    </td>

                    <td
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        borderTop: "2px solid black",
                        borderBottom: "2px solid black",
                      }}
                      className="text-center text-color-primary"
                    >
                      {Intl.NumberFormat("en-Us").format(
                        Array.isArray(reportData)
                          ? reportData.reduce(
                              (sum, item) =>
                                sum + Number(item.grand_total || 0),
                              0,
                            )
                          : 0,
                      )}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          ) : null}
        </div>
      </Paper>

      <div
        ref={componentRef}
        id="printSection"
        style={{ visibility: "hidden" }}
        className="tablePrint"
      >
        <div id="tableboot mt-4">
          <div className="d-flex">
            <div className="">
              <img
                style={{ height: 100, width: 110, paddingLeft: "20px" }}
                src={icon}
                alt="logo"
              />
            </div>
            <div className="mx-5" style={{ paddingTop: "10px" }}>
              <h1>{unitName}</h1>
              <h3>
                School Books Stock For The Financial Year {sessionName} Till
                Date {date}
              </h3>
            </div>
          </div>
          <Table className="mt-4" responsive>
            <thead>
              <tr id="tbl">
                <th className="text-center" style={{ fontSize: "18px" }}>
                  School Name
                </th>
                {!isCombine && (
                  <th className="text-center" style={{ fontSize: "18px" }}>
                    Title
                  </th>
                )}
                <th className="text-center" style={{ fontSize: "18px" }}>
                  Quantity
                </th>
                <th className="text-center" style={{ fontSize: "18px" }}>
                  Amount
                </th>
              </tr>
            </thead>

            <tbody>
              {Array.isArray(reportData) &&
                reportData.map((schoolBook, sbIndex) => (
                  <React.Fragment key={sbIndex}>
                    {isCombine ? (
                      <tr className="tbl">
                        <td
                          className="text-center"
                          style={{
                            fontSize: "16px",
                            color: `${config.txtColor}`,
                          }}
                        >
                          {
                            customerList.find(
                              (customer) =>
                                customer.value == schoolBook?.customer_id,
                            )?.label
                          }{" "}
                          ({schoolBook?.customer_name})
                        </td>
                        <td
                          className="text-center"
                          style={{ fontSize: "16px" }}
                        >
                          {Intl.NumberFormat("en-US").format(
                            schoolBook?.total_quantity || 0,
                          )}
                        </td>
                        <td
                          className="text-center"
                          style={{ fontSize: "16px" }}
                        >
                          {Intl.NumberFormat("en-US").format(
                            schoolBook?.grand_total || 0,
                          )}
                        </td>
                      </tr>
                    ) : (
                      <>
                        {/* Customer Header */}
                        <tr className="tbl">
                          <td
                            colSpan={4}
                            className="text-start"
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: `${config.txtColor}`,
                            }}
                          >
                            {
                              customerList.find(
                                (customer) =>
                                  customer.value == schoolBook?.customer_id,
                              )?.label
                            }{" "}
                            ({schoolBook?.customer_name})
                          </td>
                        </tr>

                        {/* Items */}
                        {Array.isArray(schoolBook?.items) &&
                          schoolBook.items.map((item, itemIndex) => (
                            <tr className="tbl" key={itemIndex}>
                              <td></td>
                              <td
                                className="text-center"
                                style={{ fontSize: "16px" }}
                              >
                                {item?.title}
                              </td>
                              <td
                                className="text-center"
                                style={{ fontSize: "16px" }}
                              >
                                {Intl.NumberFormat("en-US").format(
                                  item?.quantity || 0,
                                )}
                              </td>
                              <td
                                className="text-center"
                                style={{ fontSize: "16px" }}
                              >
                                {Intl.NumberFormat("en-US").format(
                                  item?.total || 0,
                                )}
                              </td>
                            </tr>
                          ))}

                        {/* Totals */}
                        <tr className="tbl">
                          <td className="text-center fw-bold"></td>
                          <td
                            className="text-center fw-bold"
                            style={{
                              fontSize: "18px",
                              borderTop: "2px solid black",
                              borderBottom: "2px solid black",
                            }}
                          >
                            Total
                          </td>
                          <td
                            className="text-center fw-bold"
                            style={{
                              fontSize: "18px",
                              borderTop: "2px solid black",
                              borderBottom: "2px solid black",
                            }}
                          >
                            {Intl.NumberFormat("en-US").format(
                              schoolBook?.total_quantity || 0,
                            )}
                          </td>
                          <td
                            className="text-center fw-bold"
                            style={{
                              fontSize: "18px",
                              borderTop: "2px solid black",
                              borderBottom: "2px solid black",
                            }}
                          >
                            {Intl.NumberFormat("en-US").format(
                              schoolBook?.grand_total || 0,
                            )}
                          </td>
                        </tr>
                      </>
                    )}
                  </React.Fragment>
                ))}

              <tr id="tbl">
                {!isCombine && (
                  <td
                    style={{ color: "black", paddingLeft: "30px" }}
                    className="text-start"
                  ></td>
                )}
                <td
                  style={{
                    fontSize: "20px",
                    paddingRight: "50px",
                    fontWeight: "bold",
                    color: `${config.txtColor}`,
                  }}
                  className="text-end"
                >
                  Grand Total :-
                </td>

                <td
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    borderTop: "2px solid black",
                    borderBottom: "2px solid black",
                    color: `${config.txtColor}`,
                  }}
                  className="text-center"
                >
                  {Intl.NumberFormat("en-Us").format(
                    Array.isArray(reportData)
                      ? reportData.reduce(
                          (sum, item) => sum + Number(item.total_quantity || 0),
                          0,
                        )
                      : 0,
                  )}
                </td>

                <td
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    borderTop: "2px solid black",
                    borderBottom: "2px solid black",
                    color: `${config.txtColor}`,
                  }}
                  className="text-center"
                >
                  {Intl.NumberFormat("en-Us").format(
                    Array.isArray(reportData)
                      ? reportData.reduce(
                          (sum, item) => sum + Number(item.grand_total || 0),
                          0,
                        )
                      : 0,
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>

      <Table ref={tableRef} style={{ display: "none" }}>
        <thead>
          <tr id="tbl">
            <th className="text-center">School Name</th>
            {!isCombine && <th className="text-center">Title</th>}
            <th className="text-center">Quantity</th>
            <th className="text-center">Amount</th>
          </tr>
        </thead>

        <tbody>
          {Array.isArray(reportData) &&
            reportData.map((schoolBook, sbIndex) => (
              <React.Fragment key={sbIndex}>
                {isCombine ? (
                  <tr className="tbl">
                    <td
                      className="text-center text-color-primary"
                      style={{ fontSize: "1.1rem" }}
                    >
                      {
                        customerList.find(
                          (customer) =>
                            customer.value == schoolBook?.customer_id,
                        )?.label
                      }{" "}
                      ({schoolBook?.customer_name})
                    </td>
                    <td className="text-center" style={{ fontSize: "1.1rem" }}>
                      {Intl.NumberFormat("en-US").format(
                        schoolBook?.total_quantity || 0,
                      )}
                    </td>
                    <td className="text-center" style={{ fontSize: "1.1rem" }}>
                      {Intl.NumberFormat("en-US").format(
                        schoolBook?.grand_total || 0,
                      )}
                    </td>
                  </tr>
                ) : (
                  <>
                    {/* Customer Header */}
                    <tr className="tbl">
                      <td
                        colSpan={4}
                        className="text-start text-color-primary"
                        style={{
                          fontSize: "1.3rem",
                          fontWeight: "bold",
                        }}
                      >
                        {
                          customerList.find(
                            (customer) =>
                              customer.value == schoolBook?.customer_id,
                          )?.label
                        }{" "}
                        ({schoolBook?.customer_name})
                      </td>
                    </tr>

                    {/* Items */}
                    {Array.isArray(schoolBook?.items) &&
                      schoolBook.items.map((item, itemIndex) => (
                        <tr className="tbl" key={itemIndex}>
                          <td></td>
                          <td
                            className="text-center"
                            style={{ fontSize: "1.1rem" }}
                          >
                            {item?.title}
                          </td>
                          <td
                            className="text-center"
                            style={{ fontSize: "1.1rem" }}
                          >
                            {Intl.NumberFormat("en-US").format(
                              item?.quantity || 0,
                            )}
                          </td>
                          <td
                            className="text-center"
                            style={{ fontSize: "1.1rem" }}
                          >
                            {Intl.NumberFormat("en-US").format(
                              item?.total || 0,
                            )}
                          </td>
                        </tr>
                      ))}

                    {/* Totals */}
                    <tr className="tbl">
                      <td className="text-center fw-bold"></td>
                      <td
                        className="text-center fw-bold"
                        style={{
                          fontSize: "1.2rem",
                          borderTop: "2px solid black",
                          borderBottom: "2px solid black",
                        }}
                      >
                        Total
                      </td>
                      <td
                        className="text-center fw-bold"
                        style={{
                          fontSize: "1.2rem",
                          borderTop: "2px solid black",
                          borderBottom: "2px solid black",
                        }}
                      >
                        {Intl.NumberFormat("en-US").format(
                          schoolBook?.total_quantity || 0,
                        )}
                      </td>
                      <td
                        className="text-center fw-bold"
                        style={{
                          fontSize: "1.2rem",
                          borderTop: "2px solid black",
                          borderBottom: "2px solid black",
                        }}
                      >
                        {Intl.NumberFormat("en-US").format(
                          schoolBook?.grand_total || 0,
                        )}
                      </td>
                    </tr>
                  </>
                )}
              </React.Fragment>
            ))}

          <tr id="tbl">
            {!isCombine && (
              <td
                style={{ color: "black", paddingLeft: "30px" }}
                className="text-start"
              ></td>
            )}
            <td
              style={{
                fontSize: "1.3rem",
                paddingRight: "50px",
                fontWeight: "bold",
              }}
              className="text-end text-color-primary"
            >
              Grand Total :-
            </td>

            <td
              style={{
                fontSize: "1.3rem",
                fontWeight: "bold",
                borderTop: "2px solid black",
                borderBottom: "2px solid black",
              }}
              className="text-center text-color-primary"
            >
              {Intl.NumberFormat("en-Us").format(
                Array.isArray(reportData)
                  ? reportData.reduce(
                      (sum, item) => sum + Number(item.total_quantity || 0),
                      0,
                    )
                  : 0,
              )}
            </td>

            <td
              style={{
                fontSize: "1.3rem",
                fontWeight: "bold",
                borderTop: "2px solid black",
                borderBottom: "2px solid black",
              }}
              className="text-center text-color-primary"
            >
              {Intl.NumberFormat("en-Us").format(
                Array.isArray(reportData)
                  ? reportData.reduce(
                      (sum, item) => sum + Number(item.grand_total || 0),
                      0,
                    )
                  : 0,
              )}
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

export default SchoolBookStock;
